import { Popover } from "@mui/material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import HeaderFilterTrigger from "./HeaderFilterTrigger";
import CoordinatorFilterPanel from "./CoordinatorFilterPanel";
import { useHoverOpenMenu } from "../_hooks/useHoverOpenMenu";
import type { CoordinatorFilterValue } from "./dashboardCoordinators";

type Props = {
  label?: string;
  value: CoordinatorFilterValue;
  onChange: (next: CoordinatorFilterValue) => void;
};

/**
 * "Coordinators" column header: hovering opens the coordinator filter panel
 * (search, multi-select, Any/All). Same state as the toolbar funnel.
 */
export default function CoordinatorHeaderFilter({
  label = "Coordinators",
  value,
  onChange,
}: Props) {
  const menu = useHoverOpenMenu<HTMLDivElement>();

  return (
    <>
      <HeaderFilterTrigger
        {...menu.triggerProps}
        label={label}
        activeCount={value?.selected?.length ?? 0}
      />
      <Popover
        open={menu.isOpen}
        anchorEl={menu.anchorEl}
        onClose={menu.close}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        slotProps={{
          paper: {
            // Same look as the status menu (`.MuiMenu-list` in index.css):
            // black paper, pink border, white text.
            sx: {
              width: 320,
              borderRadius: "0.5rem",
              border: `1px solid ${getCssVariableHandler({ variableName: "--primary-pink-hex" })}`,
              overflow: "hidden",
              bgcolor: getCssVariableHandler({
                variableName: "--bg-theme-rgb",
              }),
              color: getCssVariableHandler({ variableName: "--white-rgb" }),
              backgroundImage: "none",
            },
          },
        }}
      >
        <CoordinatorFilterPanel
          value={value}
          onChange={onChange}
          active={menu.isOpen}
        />
      </Popover>
    </>
  );
}
